import type { YourReview } from 'types/testFreaks';

const sortByDate = (a: YourReview, b: YourReview) => {
    return new Date(b.date).getTime() - new Date(a.date).getTime();
};

const sortByHavingComments = (a: YourReview, b: YourReview) => {
    const aHasComment = a.extract?.length ? 1 : 0;
    const bHasComment = b.extract?.length ? 1 : 0;
    return bHasComment - aHasComment;
};

const sortByScore = (a: YourReview, b: YourReview) => {
    return b.score - a.score;
};

const sortByLikes = (a: YourReview, b: YourReview) => {
    return b.votes_up - a.votes_up;
};

export const sortReviews = (reviews: YourReview[]) => {
    reviews.sort((a, b) => {
        return (
            sortByScore(a, b) ||
            sortByHavingComments(a, b) ||
            sortByLikes(a, b) ||
            sortByDate(a, b)
        );
    });
};
